import { FormBody } from 'twyne-new.ui';

import { DefaultGrid, GridProvider, useBuildGrid } from '@/components/Grid';
import { Refresh } from '@/components/Grid/components/header/Actions';
import { Wrapper, Search, Separator, Total, Showing } from '@/components/Grid/components/header/Heading';

import { useTransactionStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useFilters from './useFilters'

function TransactionGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
  })

  return <DefaultGrid
    className='h-full'
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <Refresh />
    </Wrapper>}
  />
}

export default function TransactionGridLayout() {
  return <GridProvider store={useTransactionStore()}>
    <FormBody className='pb-4 h-full'>
      <div className='twy-bg-base-accent shadow rounded h-full'>
        <TransactionGrid />
      </div>
    </FormBody>
  </GridProvider>
}
